import { JSX } from 'react'

import { IconProps } from '../../icon'

const ChevronRight: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_1651_4484)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.9603 34.5397C18.3466 33.9261 18.3466 32.9311 18.9603 32.3174L27.2777 24L18.9603 15.6826C18.3466 15.0689 18.3466 14.0739 18.9603 13.4603C19.5739 12.8466 20.5689 12.8466 21.1826 13.4603L30.6112 22.8888C31.2248 23.5025 31.2248 24.4975 30.6112 25.1112L21.1826 34.5397C20.5689 35.1534 19.5739 35.1534 18.9603 34.5397Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_1651_4484'>
        <rect width='48' height='48' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
)

export default ChevronRight
